<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">

    <div class="l-row">
      <form-group v-if="this.colors.length > 0" :label="$t(`color.label`)" :columns="3"
        :error="getError('color', variation.sku)" :required="true">
        <multiselect v-model="color" :options="this.colors" track-by="code" label="label" selectLabel="Clique"
          selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>

      <form-group v-if="sizes.length" :label="$t(`size.label`)" :columns="3" :error="getError('size', variation.sku)"
        :required="true">
        <multiselect v-model="size" :options="sizes" track-by="code" label="label" selectLabel="Clique"
          selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
import { mapGetters } from 'vuex'
import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
import FormGroup from '@/components/template/FormGroup'
import api from '@/api'

export default {
  data: () => ({
    sizes: [],
    colors: [],
    size: null,
    color: null
  }),
  props: {
    variation: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    toModule: {
      type: Object,
      required: true
    }
  },
  async mounted () {
    this.loading = true

    this.loading = false

    this.colors = await api.getColors(this.toModule.type, this.toModule.identifier)

    if (this.variation.attributes.color !== undefined) {
      const presets = await api.getPresets()

      presets.forEach(preset => {
        if (preset.to.identifier === this.toModule.identifier) {
          if (preset.type === 'color') {
            preset.items.forEach(item => {
              if (item.from.color === this.variation.attributes.color) {
                this.colors.forEach(color => {
                  if (color.label === item.to.color) {
                    this.color = {
                      code: color.code,
                      label: color.label
                    }
                    return
                  }
                })
              }
            })
          }
        }
      })
    }
  },
  methods: {
    disabledInputs () {
      return this.variation.status === 'sent' || this.variation.status === 'error'
    },
    emitToParent (value) {
      this.$emit('change', value)
    }
  },
  watch: {
    color (value) {
      this.variation.attributes.color = value
    }
  },
  computed: {
    ...mapGetters('errors', [
      'getError'
    ])
  },
  components: {
    SharedProvideVariation,
    FormGroup
  }
}
</script>



// WEBPACK FOOTER //
// Variation.vue?5fc6f538